export default "__VITE_ASSET__5wupqxuw__"